import { CommApiInstance } from "Utils/CommApiInstance";


const TcktUseApi = async (
    evntCd: string,
) => {
    return await CommApiInstance.post(`memb/tckt/use`,{
        apiBody: {
            evntCd:evntCd
        }
    })
    .then((Resp) => Resp.data);
}

export default TcktUseApi;